<template>
    <div class="fullscreen loader-fullscreen">
        <LoaderHexeko />
    </div>
</template>

<script>
    import LoaderHexeko from './LoaderHexeko'

    export default {
        name: 'LoaderFullscreen',
        components: {
            LoaderHexeko
        }
    }
</script>